import findBySlug from "./find-by-slug";

const findSong = (
  route,
  { parentSeasonContentForSchoolLevel, parentSchoolLevel },
) => {
  // If we have a routed seasonContentForSchoolLevel,
  // then we are looking for a season song.
  if (parentSeasonContentForSchoolLevel) {
    return findBySlug(
      parentSeasonContentForSchoolLevel.songs,
      route.params.songSlug,
    );
  }

  // Otherwise, we must be looking for a school level archive song.
  return findBySlug(parentSchoolLevel.archivedSongs, route.params.songSlug);
};

export default function resolveRoutedSong(route, parents, { getters }) {
  if (!getters.containerLoaded) {
    return null;
  }

  // If no song slug is provided, fall back
  // to the (archive or season) song list.
  if (!route.params?.songSlug) {
    return null;
  }

  // Find the song by the route's song slug.
  return findSong(route, parents);
}
